export default {
  translation: {
    common: {
      emailOrUsername: 'Email или имя пользователя',
      invalidUsernameOrPassword: 'Неверное имя пользователя или пароль',
      logInToBoards: 'Вход',
      noInternetConnection: 'Нет соединения',
      pageNotFound: 'Страница не найдена',
      password: 'Пароль',
      serverConnectionFailed: 'Не могу подключиться к серверу',
      unknownError: 'Что-то пошло не так, попробуйте позже',
    },

    action: {
      logIn: 'Войти',
    },
  },
};
